import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LanguageService } from '../../services/language.service';
import { NgxHmCarouselBreakPointUp } from 'ngx-hm-carousel';
import { RouterUrls } from '../router-urls';
import { PartialProject } from '../projects.model';

@Component({
  selector: 'app-project-brand-carousel',
  templateUrl: './project-brand-carousel.component.html',
  styleUrls: ['./project-brand-carousel.component.scss']
})
export class ProjectBrandCarouselComponent implements OnInit {

  @Input() projectsSupported: PartialProject[];

  RouterUrls = RouterUrls;

  currentIndex = 0;
  speed = 5000;
  infinite = false;
  direction = 'right';
  directionToggle = true;
  autoplay = true;
  mouseEnable = true;

  breakpoints: NgxHmCarouselBreakPointUp[] = [
    {width: 1139, number: 1},
    {width: 1140767, number: 3}
  ];

  constructor(
    private languageService: LanguageService,
    private router: Router) { }

  ngOnInit(): void {
    if (this.projectsSupported.length === 1 || this.projectsSupported.length === 2){
      this.breakpoints = [
        {width: 1140767, number: 1}
      ];
    }
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
